import React from 'react';
import { Link } from 'react-router-dom';

const JoinCommunity = () => {
    const steps = [
        {
            icon: '✍️',
            title: 'Write',
            description: 'Create and submit your own funny article to the Jessster Times community.'
        },
        {
            icon: '👀',
            title: 'Get Reviewed',
            description: 'Every submission is reviewed to make sure only top-notch funny content gets published.'
        },
        {
            icon: '🎉',
            title: 'Get Published',
            description: 'If your article is approved, it becomes part of the Jessster Times community.'
        },
        {
            icon: '💬',
            title: 'Get Feedback',
            description: 'See whether your submission was approved or denied, along with a note explaining the decision.'
        }
    ];

const isAuthenticated = Boolean(localStorage.getItem('authToken'));

    return (
        <section
            className="mb-5"
            style={{
                backgroundColor: '#f8f9fa',
                borderRadius: '24px',
                padding: '40px 30px'
            }}
        >
            {/* Header */}
            <div className="text-center mb-5">
                <h2 className="fw-bold mb-2">
                    ✍️ Don't Just Read Jessster Times — Be Part of It.
                </h2>

                <p
                    className="text-muted mb-0"
                    style={{
                        maxWidth: '700px',
                        margin: '0 auto',
                        fontSize: '1.05rem'
                    }}
                >
                    Think you've got something funny to say?
                    Create an account and submit your own article to the community.
                </p>
            </div>

            {/* Submission Steps */}
            <div className="row g-4 justify-content-center">
                {steps.map((step, index) => (
                    <div
                        key={index}
                        className="col-6 col-md-3"
                    >
                        <Link
                            to="/stories"
                            style={{
                                textDecoration: 'none',
                                color: 'inherit'
                            }}
                        >
                            <div
                                className="card h-100 border-0 shadow-sm"
                                style={{
                                    borderRadius: '16px',
                                    padding: '25px 15px',
                                    textAlign: 'center',
                                    cursor: 'pointer',
                                    transition: 'transform 0.2s ease, box-shadow 0.2s ease'
                                }}
                                onMouseEnter={(e) => {
                                    e.currentTarget.style.transform = 'translateY(-6px)';
                                    e.currentTarget.style.boxShadow =
                                        '0 10px 25px rgba(0, 0, 0, 0.12)';
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.transform = 'translateY(0)';
                                    e.currentTarget.style.boxShadow = '';
                                }}
                            >
                                <div
                                    style={{
                                        fontSize: '2.5rem',
                                        marginBottom: '15px'
                                    }}
                                >
                                    {step.icon}
                                </div>

                                <h5 className="fw-bold mb-2">
                                    {step.title}
                                </h5>

                                <p
                                    className="text-muted mb-0"
                                    style={{
                                        fontSize: '0.95rem',
                                        lineHeight: '1.5'
                                    }}
                                >
                                    {step.description}
                                </p>
                            </div>
                        </Link>
                    </div>
                ))}
            </div>

            {/* Quality Control Message */}
            <div
                className="text-center mt-5 mb-4"
                style={{
                    maxWidth: '700px',
                    marginLeft: 'auto',
                    marginRight: 'auto'
                }}
            >
                <p className="fw-bold mb-1">
                    🎭 We want the good stuff.
                </p>

                <p className="text-muted mb-0">
                    Every article is reviewed before it gets published,
                    so the community stays funny, original, and worth reading.
                </p>
            </div>

            {/* CTA */}
            <div className="text-center">
                <Link
                    to={isAuthenticated ? "/stories" : "/register"}
                    className="btn btn-dark btn-lg fw-bold px-4"
                >
                    {isAuthenticated
                        ? "Create Your Story Now →"
                        : "Create Your Free Account →"
                    }
                </Link>

                {!isAuthenticated && (
                    <div className="text-muted small mt-2">
                        Free to join. No subscription required.
                    </div>
                )}
            </div>
        </section>
    );
};

export default JoinCommunity;
